import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Voltar")
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.state.computedVisivel)
    ? (_openBlock(), _createBlock(_component_a_modal, {
        key: 0,
        keyboard: false,
        centered: "",
        width: "100%",
        "wrap-class-name": "ui-full-modal",
        title: _ctx.obtemTituloModal(),
        visible: _ctx.state.computedVisivel,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.computedVisivel) = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "ui-button -second",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.computedVisivel = false))
            }, _hoisted_2)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            id: "uni-reserva",
            ref: "el",
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: _ctx.appBase.carregando
              }, {
                default: _withCtx(() => [
                  ((_ctx.state.apresentarMapa))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_ctx.state.carregaPreviaMapa)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 'img-' + _ctx.state.chaveImg,
                              id: "AreaImgMapa",
                              src: _ctx.state.area.mapa,
                              style: {"max-width":"100%","height":"auto","z-index":"9"}
                            }, null, 8, _hoisted_4))
                          : _createCommentVNode("", true),
                        ((_ctx.state.area.codigo > 0 && !_ctx.state.carregaPreviaMapa))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                (_openBlock(), _createElementBlock("div", {
                                  key: 'mapw' + _ctx.state.area.mapaLargura,
                                  class: "parking-lot",
                                  style: _normalizeStyle('width:' + _ctx.state.area.mapaLargura + 'px;height:' + _ctx.state.area.mapaAltura + 'px; background-image: url(' + _ctx.state.area.mapa + ');background-repeat: no-repeat;background-position:center;background-size: contain;z-index:10')
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.area.boxes, (box, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      (_ctx.boxDisponivel(box))
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "parking-space ui-box-disponivel",
                                            style: _normalizeStyle('left:' + box.posicaoX + 'px;top:' + box.posicaoY + 'px;height:' + box.altura+ 'px;width:' +box.largura+ 'px;background-color:' + _ctx.state.statusBoxDisponivel.cor + ';' + box.estilo)
                                          }, [
                                            _createElementVNode("span", {
                                              class: "ui-parking-identificacao",
                                              style: _normalizeStyle('position:relative;' + box.estiloIdentificacao)
                                            }, _toDisplayString(box.identificacao), 5)
                                          ], 4))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "parking-space ui-box-indisponivel",
                                            title: "Reservado/Indisponível",
                                            style: _normalizeStyle('left:' + box.posicaoX + 'px;top:' + box.posicaoY + 'px;height:' + box.altura+ 'px;width:' +box.largura+ 'px;background-color:' + _ctx.obterCorStatus(box) + ';' + box.estilo)
                                          }, [
                                            _createElementVNode("span", {
                                              class: "ui-parking-identificacao",
                                              style: _normalizeStyle('position:relative;' + box.estiloIdentificacao)
                                            }, _toDisplayString(box.identificacao), 5)
                                          ], 4))
                                    ], 64))
                                  }), 128))
                                ], 4))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "visible"]))
    : _createCommentVNode("", true)
}